import { Box, Text, SimpleGrid } from "@chakra-ui/react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { InvoiceFormData } from "@/types";
import { FormNumberInput } from "./FormNumberInput";
import { Heading } from "@digital-services-gard-as/anchor-react";

type Props = {
    userRole: string;
};

export const Expenses = ({ userRole }: Props) => {
    const { t } = useTranslation(["invoices", "errorMessages"]);
    const {
        watch,
        control,
        formState: { errors }
    } = useFormContext<InvoiceFormData>();
    const currency = watch("bankAccount.currency");

    return (
        <Box bg="white" p={{ base: "1rem", md: "1.5rem" }} borderRadius="md" boxShadow="xs">
            <Heading size="md" style={{ marginBottom: "0.5rem" }}>
                {t("invoices:createInvoice.feesAndExpenses.expenses")}
            </Heading>
            <Text maxW="40rem" mb={4}>
                {t("invoices:createInvoice.feesAndExpenses.provideValues")}
            </Text>
            {userRole === "Client" ? (
                <FormNumberInput
                    id="claimSettlements"
                    label={t("invoices:createInvoice.feesAndExpenses.claimSettlements")}
                    isRequired={false}
                    errorMessage={errors.claimSettlements?.message}
                    control={control}
                    currency={currency}
                />
            ) : (
                <>
                    {/*eslint-disable-next-line no-magic-numbers*/}
                    <SimpleGrid columns={{ base: 1, md: 2 }} gap={4} mb={4}>
                        <FormNumberInput
                            id="correspondentCosts"
                            label={t("invoices:createInvoice.feesAndExpenses.correspondentFees")}
                            isRequired={false}
                            errorMessage={errors.correspondentCosts?.message}
                            control={control}
                            currency={currency}
                        />
                        <FormNumberInput
                            id="surveyorCosts"
                            label={t("invoices:createInvoice.feesAndExpenses.surveyorFees")}
                            isRequired={false}
                            errorMessage={errors.surveyorCosts?.message}
                            control={control}
                            currency={currency}
                        />
                    </SimpleGrid>
                    <Box flex="1" minW="260px" w="100%">
                        <FormNumberInput
                            id="expertCosts"
                            label={t("invoices:createInvoice.feesAndExpenses.expertFees")}
                            isRequired={false}
                            errorMessage={errors.expertCosts?.message}
                            control={control}
                            currency={currency}
                        />
                    </Box>
                </>
            )}
        </Box>
    );
};
